<template>
  <div :class="[outlined ? 'outlined-chip' : 'solid-chip']">
    <v-chip :small="small" :color="chipColor" :dark="isDarkChip">
      <v-icon v-if="icon" left small>{{ icon }}</v-icon>
      <slot>
        <Typography variant="body-2"> {{ text }}</Typography>
      </slot>
    </v-chip>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
export default {
  name: "StatusChip",
  components: {
    Typography,
  },
  props: {
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["success", "warning", "error", "info", "default", "dark"].includes(v),
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    chipColor() {
      if (this.variant === "default") return "surface";
      if (this.variant === "dark") return "#212121";
      return this.variant;
    },
    isDarkChip() {
      return this.variant === "dark" || this.variant === "success" || this.variant === "error";
    },
  },
};
</script>

<style scoped>
.v-chip {
  pointer-events: none;
}
.v-chip.v-size--default {
  padding: 4px 12px !important;
}
.v-chip.v-size--small {
  padding: 0 8px !important;
}
.outlined-chip ::v-deep .v-chip {
  border: 1px solid currentColor !important;
  background-color: transparent !important;
}
.outlined-chip ::v-deep .v-chip.success {
  color: var(--v-success-base) !important;
  border-color: var(--v-success-base) !important;
  background-color: var(--v-successLight-base) !important;
}
.outlined-chip ::v-deep .v-chip.warning {
  color: var(--v-warningText-base) !important;
  border-color: var(--v-warning-base) !important;
  background-color: var(--v-warningLight-base) !important;
}
.outlined-chip ::v-deep .v-chip.error {
  color: var(--v-errorText-base) !important;
  border-color: var(--v-error-base) !important;
  background-color: var(--v-errorLight-base) !important;
}
.outlined-chip ::v-deep .v-chip.info {
  color: var(--v-infoText-base) !important;
  border-color: var(--v-info-base) !important;
  background-color: var(--v-infoLight-base) !important;
}
.outlined-chip ::v-deep .v-chip.surface {
  color: var(--v-surfaceText-base) !important;
  border-color: var(--v-surface-base) !important;
  background-color: var(--v-surfaceLight-base) !important;
}

/* Solid warning chip: black text (per design) */
.solid-chip ::v-deep .v-chip.warning {
  color: #000000 !important;
}

/* Ensure white text on dark-background chips */
.solid-chip ::v-deep .v-chip.v-chip--dark,
.solid-chip ::v-deep .v-chip.theme--dark {
  color: #ffffff !important;
}
.solid-chip ::v-deep .v-chip.v-chip--dark .typography,
.solid-chip ::v-deep .v-chip.theme--dark .typography {
  color: #ffffff !important;
}
.solid-chip ::v-deep .v-chip.v-chip--dark .v-icon,
.solid-chip ::v-deep .v-chip.theme--dark .v-icon {
  color: #ffffff !important;
}
</style>
